import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MainDrawer from './MainDrawer';
import SubDrawer from './SubDrawer';
import { subDrawerInitialState } from './config/SubDrawerConfig';
import { SubDrawerData, DrawerFunctions } from '../../types/Drawer';

import '../../assests/Main.scss';

function Drawer({
  onClickFunctions,
  activeNav,
  activeSubNav,
  hiddenNavKeys,
  disabledNavKeys,
}: {
  onClickFunctions: DrawerFunctions;
  activeNav: string;
  activeSubNav: string;
  hiddenNavKeys: string[];
  disabledNavKeys: string[];
}) {
  const [subDrawerData, setSubDrawerData] = useState<SubDrawerData>(subDrawerInitialState);

  const drawerFunctions = onClickFunctions || {
    home: () => { console.log('Home Clicked'); },
    applications: () => { console.log('Applications Clicked'); },
    workflows: () => { console.log('Workflows Clicked'); },
    credentials: () => { console.log('Credentials Clicked'); },
    usage: () => { console.log('Usage Clicked'); },
    logout: () => { console.log('Logout Clicked'); },
    analytics: () => { console.log('Analytics Clicked'); },
  };

  return (
    <div id="drawer__wrapper">
      <MainDrawer
        drawerFunctions={drawerFunctions}
        setSubDrawerData={setSubDrawerData}
        activePage={activeNav}
        hiddenNavKeys={hiddenNavKeys}
        disabledNavKeys={disabledNavKeys}
      />
      <SubDrawer
        drawerFunctions={drawerFunctions}
        subDrawerData={subDrawerData}
        activePage={activeSubNav}
        hiddenNavKeys={hiddenNavKeys}
        disabledNavKeys={disabledNavKeys}
      />
    </div>
  );
}

Drawer.defaultProps = {
  hiddenNavKeys: [],
  disabledNavKeys: [],
};

Drawer.propTypes = {
  onClickFunctions: PropTypes.object.isRequired,
  activeNav: PropTypes.string.isRequired,
  activeSubNav: PropTypes.string.isRequired,
  hiddenNavKeys: PropTypes.array,
  disabledNavKeys: PropTypes.array,
};

export default Drawer;
